var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9982 6.03418C44.4992 6.03418 39.9986 10.5347 39.9986 16.0337C39.9986 16.6868 40.0648 17.3246 40.1862 17.9439L22.2493 28.4083C20.4436 25.7731 17.4166 24.0335 13.9996 24.0335C8.50066 24.0335 4 28.5341 4 34.033C4 39.532 8.50066 44.0326 13.9996 44.0326C17.4166 44.0326 20.4436 42.293 22.2493 39.6578L40.1861 50.1224C40.0649 50.7415 39.9986 51.379 39.9986 52.0324C39.9986 57.5313 44.4992 62.0319 49.9982 62.0319C55.4971 62.0319 59.9978 57.5313 59.9978 52.0324C59.9978 46.5334 55.4971 42.0329 49.9982 42.0329C46.5812 42.0329 43.5542 43.7724 41.7485 46.4076L23.8117 35.943C23.9329 35.324 23.9992 34.6864 23.9992 34.033C23.9992 33.38 23.933 32.7423 23.8116 32.1231L41.7484 21.6585C43.5541 24.2937 46.5811 26.0335 49.9981 26.0335C55.497 26.0335 59.9977 21.5326 59.9977 16.0337C59.9977 10.5347 55.4971 6.03418 49.9982 6.03418Z",
    fill: "url(#paint0_linear_498_7099)",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9982 3.40244C44.1679 3.40244 39.3986 8.1716 39.3986 14.002C39.3986 14.5474 39.4421 15.0822 39.5231 15.6044L22.4162 25.5845C20.4776 23.0498 17.4251 21.4018 13.9996 21.4018C8.1693 21.4018 3.4 26.1709 3.4 32.0013C3.4 37.8316 8.1693 42.6008 13.9996 42.6008C17.425 42.6008 20.4776 40.9528 22.4162 38.4181L39.523 48.3985C39.4421 48.9204 39.3986 49.4549 39.3986 50.0006C39.3986 55.8309 44.1679 60.6002 49.9982 60.6002C55.8285 60.6002 60.5978 55.8309 60.5978 50.0006C60.5978 44.1703 55.8285 39.4011 49.9982 39.4011C46.5727 39.4011 43.5202 41.0491 41.5816 43.5838L24.4748 33.6035C24.5557 33.0816 24.5992 32.547 24.5992 32.0013C24.5992 31.4558 24.5557 30.9212 24.4747 30.3991L41.5815 20.4188C43.5201 22.9535 46.5726 24.6017 49.9981 24.6017C55.8284 24.6017 60.5977 19.8323 60.5977 14.002C60.5977 8.1716 55.8285 3.40244 49.9982 3.40244Z",
    stroke: "url(#paint1_linear_498_7099)",
    strokeWidth: 1.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_498_7099",
    x1: 31.9989,
    y1: 6.03418,
    x2: 31.9989,
    y2: 66.6692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_498_7099",
    x1: 44.6984,
    y1: -9.14283,
    x2: 55.3231,
    y2: 58.3276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.7d015664673e83cfe790debfb2d1d090.svg";
export { ForwardRef as ReactComponent };